import {
  Banner,
  BannerActions,
  BannerContent,
  Button,
  StackLayout, Text,
} from "@salt-ds/core";

import { CloseIcon } from "@salt-ds/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { hideBanner } from "src/reducers/slices/BannerSlice";

const NotificationBanner = () => {
  const dispatch = useDispatch();
  const { isVisible, status, message, header,className } = useSelector(
    (state: RootState) => state.banner,
  );

  if (!isVisible) return null;
  const handleClose = () => {
    dispatch(hideBanner());
  };

  return (
    <StackLayout gap={3}>
      <Banner status={status}>
        <BannerContent role="status">
          <Text>
          <strong>{header}</strong>
        </Text>

          <div className={className}>{message}</div>
        </BannerContent>
        <BannerActions>
          <Button aria-label="close" variant="secondary" onClick={handleClose}>
            <CloseIcon />
          </Button>
        </BannerActions>
      </Banner>
    </StackLayout>
  );
};

export default NotificationBanner;
